module.exports = __webpack_public_path__ + "img/202411290303.8d69719e.png";